import { NotificationType, PrintType, TenantAvailabilityState, WaybillType } from '@shared/service-proxies/service-proxies';

export class AppTenantAvailabilityState {
    static Available: number = TenantAvailabilityState._1;
    static InActive: number = TenantAvailabilityState._2;
    static NotFound: number = TenantAvailabilityState._3;
}
// TODO: AK Düzeltilecek
export class AppPrintType {
    static LabelProduct: number = PrintType._1;
    static LabelShelf: number = PrintType._2;
    static LabelContainer: number = PrintType._3;
    static LabelShipment: number = PrintType._4;
    static EDocument: number = PrintType._5;
    static LabelPackingListAll: number = PrintType._6;
    static CombinedOrders: number = PrintType._7;
    static CombinedLabelShipment: number = PrintType._8;
    static PrintType9: number = PrintType._8;
    static Dispatch: number = PrintType._11;
    static Kit: number = PrintType._12;
}
export class AppWorkActivityType {
    static Receiving = 1;
    static Shipping = 2;
    static TransferInShelves = 3;
    static TransferInStorages = 4;
    static TransferInWarehouseShipping = 5;
    static FullStocktaking = 6;
    static PartialStocktaking = 7;
    static SpotCheck = 8;
    static CancelOrder = 9;
    static Replenishment = 10;
    static CancelOrderPartly = 11;
    static CancelTransferWarehousePartly = 12;
    static CancelTransferWarehouse = 13;
    static TransferInWarehouseReceiving = 14;
    static Production = 15;
}
export class AppStockMovementType {
    static StorageMovement = 1;
    static ShelfMovement = 2;
}
export class AppWorkActionType {
    static Create = 1;
    static Finish = 2;
    static Control = 3;
    static Placement = 4;
    static Picking = 5;
    static Package = 6;
    static Shipment = 7;
    static Replacement = 8;
    static StockTaking = 9;
    static Replenish = 10;
    static ProductRecode = 11;
    static StockReset = 12;
}

export class AppPickingType {
    static Cargo: number = 1;
    static Delivery: number = 2;
    static Desk: number = 3;
    static NormalReturn: number = 4;
    static DefectiveReturn: number = 5;
}

export class AppShippingType {
    static City: string = "CITY";
}
export class AppParameterNames {
    static AutoInvoice: string = "AutoInvoice";
    static FullStocktaking: string = "FullStocktaking";
    static PartialStocktaking: string = "PartialStocktaking";
    static RandomStockTaking: string = "SpotCheck";
    static FastStockTaking: string = "FastStockTaking";
}
export class AppNotificationType {
    static General: number = NotificationType._0;
    static Picking: number = NotificationType._1;
    static Placement: number = NotificationType._2;
    static Control: number = NotificationType._3;
}

export class AppWaybillType {
    static All: number = WaybillType._0;
    static Purchase: number = WaybillType._1;
    static ReturnSale: number = WaybillType._2;
    static DatTransfer: number = WaybillType._3;
    static Production: number = WaybillType._4;
    static Examination: number = WaybillType._5;
    static Export: number = WaybillType._6;
    static Import: number = WaybillType._7;
    
    //static Importation: number = WaybillType._6;
}
